(function () {
  var frame;
  function update() {
    frame = null;
    document.querySelectorAll('.customize-setting-price-info-icon-container').forEach(function (container) {
      var card = container.parentElement;
      var label = card.querySelector('.customize-theme-price-info');
      var icon = container.querySelector('.customize-setting-price-info-icon');
      if (!label || !icon || !label.getClientRects().length) return;
      var range = document.createRange();
      range.selectNodeContents(label);
      var text = range.getBoundingClientRect();
      var origin = container.getBoundingClientRect();
      icon.classList.add('lucce-card-price-icon');
      icon.style.setProperty('--lucce-card-info-left', (text.right - origin.left + 6) + 'px');
      icon.style.setProperty('--lucce-card-info-top', (text.top + text.height / 2 - origin.top - 8) + 'px');
    });
  }
  function schedule() {
    if (!frame) frame = requestAnimationFrame(update);
  }
  function init() {
    new MutationObserver(schedule).observe(document.body, { childList: true, subtree: true, characterData: true });
    window.addEventListener('resize', schedule);
    window.addEventListener('load', schedule);
    document.addEventListener('shopify:section:load', schedule);
    if (document.fonts) document.fonts.ready.then(schedule);
    schedule();
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', init);
  else init();
})();
